/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class BikeModelApi {
    static getInstance() {
        if (!this.instance) this.instance = new BikeModelApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取车辆信息
    // async getBikeInfo (user_id, frame_number, assembly_code){
    //     let url = `/api/report/sys/vehicle/${user_id}?frame_number=${frame_number}&assembly_code=${assembly_code}`
    //     let result = await this.getData(url,{},'GET')
    //     return result
    // }
    
    // 车型分页查询（POST /sys/vehicle/model/list?page_num=&page_size=）
    async getBikeModelList(param = {}, page_num, page_size){
        let url = `/api/sys/vehicle/model/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url, param, 'POST')
        return result
    }

    // 新增车型
    async addBikeModel(param){
        let url = `/api/sys/vehicle/model`
        let result = await this.getData(url, param, 'POST')
        return result
    }

    // 取消车型（PUT /sys/vehicle/model/{id}）
    async cancelBikeModel(id, param){
        let url = `/api/sys/vehicle/model/${id}`
        let result = await this.getData(url, param, 'PUT')
        return result
    }

    

}

export {
    BikeModelApi
}